import { RidangoReduxAction } from '@ridango/core';

import { RouteDirectionEntity } from '../../schedule.model';
import { RouteDirectionActions } from './route-direction.action';

export const ROUTE_DIRECTION_STATE_KEY = 'routeDirection';

export interface RouteDirectionState {
    entities: { [id: string]: RouteDirectionEntity };
    selectedId: string;
}

export const ROUTE_DIRECTION_INITIAL_STATE: RouteDirectionState = {
    entities: {},
    selectedId: null,
};

export function routeDirectionReducer(
    state: RouteDirectionState = ROUTE_DIRECTION_INITIAL_STATE,
    action: RidangoReduxAction
): RouteDirectionState {
    switch (action.type) {
        case RouteDirectionActions.SET_ROUTE_DIRECTIONS_ENTITY:
            return {
                ...state,
                entities: action.payload,
            };
        case RouteDirectionActions.SET_SELECTED_ROUTE_DIRECTION:
            return {
                ...state,
                selectedId: action.payload,
            };
    }

    return state;
}
